
/**
 * 알림 상태 정보
 */
export type NotificationListResponseNotificationsItemStatus = {
  /** 읽음 상태 */
  isRead: boolean;
};
